import { useCallback, useState } from 'react';

type OpenState<T> = { state: 'opened'; extraData: T };
type ClosedState = { state: 'closed' };

type DialogState<T> =
  | OpenState<T>
  | ClosedState;

export type DialogController<T = void> = {
  isOpen: true;
  extraData: T;
  reset: () => void;
  open: (extraData: T) => void;
} | {
  isOpen: false;
  reset: () => void;
  open: (extraData: T) => void;
};

export function useDialog<T = void>(): DialogController<T> {
  const [state, setState] = useState<DialogState<T>>({ state: 'closed' });

  const open = useCallback(
    (extraData: T): void => {
      setState({ state: 'opened', extraData });
    },
    []
  );

  const reset = useCallback((): void => {
    setState({ state: 'closed' });
  }, []);

  if (state.state === 'opened') {
    return {
      isOpen: true,
      extraData: state.extraData,
      open,
      reset,
    }
  } else {
    return {
      isOpen: false,
      open,
      reset,
    }
  }
}
